import { render } from "./FormArticolo.vue?vue&type=template&id=013d55e1"
import script from "./FormArticolo.vue?vue&type=script&lang=js"
export * from "./FormArticolo.vue?vue&type=script&lang=js"

import "./FormArticolo.vue?vue&type=style&index=0&id=013d55e1&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__